export default "__VITE_ASSET__a5h2ByOZ__"